<template lang="pug">
  .flex-1
    .row.mx-5.mt-5(v-if="isLoad === 'unauthorization'")
      div(class="alert alert-danger" style="margin: 0 auto;" role="alert") Сгенерируйте счет занового в приложении "Трекер посылок 2"
    .row.mx-5.mt-5(v-if="isLoad === 'no'")
      div(class="alert alert-danger" style="margin: 0 auto;" role="alert") Возникла ошибка, попробуйте перезагрузить страницу.
    .row.mx-5.mt-5(v-if="isLoad === 'loading'")
      .row-c
        <i class="fas fa-sync-alt fa-spin"></i>
    .row.mx-5.mt-5(v-if="isLoad === 'yes'")
      table.table
        tbody
          tr
            td(rowspan="2" style="height: 100%;")
              .box-sb
                p {{ bank_name }}
                p Банк получателя
            td(style="text-align: center; vertical-align: middle;") БИК
            td(rowspan="2" style="height: 100%;")
              .box-sb
                p {{ bik }}
                p {{ ks }}
          tr
            td(style="text-align: center; vertical-align: middle;") Сч. №
          tr
            td ИНН {{ inn }}
            td(rowspan="2" style="text-align: center; vertical-align: middle;") Сч. №
            td(rowspan="2" style="vertical-align: middle;") {{ rs }}
          tr
            td(style="height: 100%;")
              .box-sb
                p {{ name }}
                p Получатель
    .row.mx-5.mt-5(v-if="isLoad === 'yes'")
      h2 Счет на оплату № {{ bill_number }} от {{ bill_date }}г.
    .row.mx-5.mt-2(v-if="isLoad === 'yes'")
      p(style="width: 100%; margin-bottom: 0 !important") <b>Поставщик:</b>
      p(style="width: 100%;") {{ name }}, ИНН {{ inn }}, {{ address }}
      p(style="width: 100%; margin-bottom: 0 !important") <b>Покупатель:</b> 
      p(style="width: 100%;") {{ buyer_data }}
    .row.mx-5.mt-2(v-if="isLoad === 'yes'")
      table.table
        thead
          tr
            th №
            th Товары (работы, услуги)
            th Кол-во
            th Ед.
            th НДС
            th Цена
            th Сумма
        tbody
          tr
            td 1
            td Продление приложения "Трекер посылок 2"
            td 1
            td шт
            td Без НДС
            td {{ parseInt(Math.ceil(this.$route.query.summ)) }},00
            td {{ parseInt(Math.ceil(this.$route.query.summ)) }},00
    .row.mx-5.mt-2(v-if="isLoad === 'yes'")
      table
        tbody
          tr
            td Всего наименований на сумму {{ parseInt(Math.ceil(this.$route.query.summ)) }},00 руб.
            td(style="text-align: right;")
              b Итого к оплате: {{ parseInt(Math.ceil(this.$route.query.summ)) }},00
    .row.mx-5.mt-2(v-if="isLoad === 'yes'")
      p 
        b {{ string_summ[0].toUpperCase()+string_summ.slice(1).toLowerCase() }}
    .row.mx-5.mt-2(v-if="isLoad === 'yes'")
      .row-empty
    .row.mx-5.mt-5(v-if="isLoad === 'yes'")
      .row-pay
        .pay-item
          b Руководитель
          span
        .pay-item
          b Бухгалтер
          span
    .row.mx-5.mt-2(v-if="isLoad === 'yes'")
      button(@click="print" type="button" class="btn btn-primary") Скачать или распечатать
</template>

<script>
import moment from 'moment'
import urls from '@/lib/urls'
import common from '@/lib/common'
import axios from 'axios'

var rubles = require('rubles').rubles

moment.locale('ru')

export default {
  data() {
    return {
      buyer_data: JSON.parse(this.$route.query.data),
      bill_number: '',
      bill_date: '',
      string_summ: '',
      isLoad: 'loading',
      address: '',
      bank_name: '',
      bik: '',
      inn: '',
      ks: '',
      name: '',
      orgnip: '',
      rs: ''
    }
  },
  created() {
    this.string_summ = rubles(parseInt(Math.ceil(this.$route.query.summ))).replace(' 00 копеек', '')
    this.bill_date = moment().format('DD MMMM YYYY')
    this.bill_number = this.$route.query.bill_number
    this.sendData()
  },
  methods: {
    print(){
      window.print()
    },
    async sendData(){
      const self = this

      let data = {
        requisites: JSON.parse(this.$route.query.data)
      }

      let headers = {
        headers: { 
          Authorization: `Bearer ${localStorage.token}`,
          "X-Bitrix-Domain": this.$route.query.domain
        }
      }
      
      axios.post(urls.getPayAccount((parseInt(Math.ceil(this.$route.query.summ)) * 100), this.bill_number), data, headers).then(response => {
        // console.log(response.data)
        self.address = response.data.address
        self.bank_name = response.data.bank_name
        self.bik = response.data.bik
        self.inn = response.data.inn
        self.ks = response.data.ks
        self.name = response.data.name
        self.orgnip = response.data.orgnip
        self.rs = response.data.rs
        self.isLoad = 'yes'
      }).catch(error => {
        let errorParsed = common.errorQueryHandler(error)

        if(errorParsed.type === 'unauthorization'){
          self.isLoad = 'unauthorization'
        } else if(errorParsed.type === 'some'){
          console.log(errorParsed.error)
          self.isLoad = 'no'
        } else{
          console.log(error)
          self.isLoad = 'no'
        }
      })
    }
  },
}
</script>

<style scoped>
  table{
    width: 100%;
    border-collapse: collapse;
  }
  .box-sb{
    /* display: inline-flex;
    height: 100%;
    flex-direction: column;
    justify-content: space-between; */
  }
  .box-sb p:last-child{
    margin-bottom: 0 !important;
  }
  .box-sb p{
    margin-bottom: 25px;
  }
  .table td{
    height: 100%;
  }
  .table, .table td, .table th{
    border: 1px solid #000000;
  }
  .row-empty{
    width: 100%;
    border-bottom: 2px solid #000000;
  }
  .row-pay{
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;   
  }
  .pay-item{
    display: flex;
    flex-direction: row;
  }
  .pay-item span{
    border-bottom: 2px solid #000000;
    width: 150px;
    display: block;
    margin-left: 10px;
  }
  .row-c{
    width: 100%;
    text-align: center;
    font-size: 30px;
  }
</style>